let maintenanceInfo = null;
const listeners = new Set();

export function getMaintenanceInfoSnapshot() {
  return maintenanceInfo;
}

export function setMaintenanceInfo(info) {
  maintenanceInfo = info;
  listeners.forEach((listener) => listener());
}

export function subscribeMaintenance(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
